import "../Legal/styles.css";

const TermsAndConditions = () => {
  return (
    <div className="legal-page">
      <h1 className="legal-title">Hogcloud Terms and Conditions</h1>

      <section className="legal-content">
        <h2>Use of Hogcloud Site and Services</h2>
        <p>
          By using the Hogcloud website, purchasing products, submitting custom
          order details, or participating in any Hogcloud service or program,
          you agree to use the site and services lawfully, respectfully, and in
          a way that does not interfere with the experience of other customers,
          partners, or visitors.
        </p>
        <p>
          Hogcloud may update, suspend, refuse, or discontinue any site feature,
          product, order, listing, or service when needed to protect customers,
          comply with applicable law, prevent misuse, or maintain the quality
          and reliability of Hogcloud services.
        </p>
      </section>

      <section className="legal-content">
        <h2>Hogcloud Networking Program</h2>
        <p>
          The Hogcloud Networking program allows participating businesses to
          provide business contact information that may be displayed publicly on
          Hogcloud websites, pages, directories, printed materials, digital
          materials, or related promotional channels. This program is intended
          to help promote participating businesses and make it easier for
          interested customers, collaborators, or community members to find and
          contact them.
        </p>
        <p>
          Businesses are responsible for making sure the information they submit
          is accurate, current, authorized for public use, and appropriate for
          publication. Submitted information may include details such as a
          business name, contact name, email address, phone number, website,
          service area, social media links, business description, logo, or other
          business-facing contact information.
        </p>
        <p>
          Participation in the Hogcloud Networking program does not create an
          employment, agency, franchise, endorsement, partnership, or joint
          venture relationship between Hogcloud and any participating business.
          Hogcloud may choose how and where program information is displayed and
          may edit formatting, correct obvious errors, or decline content that
          is inaccurate, misleading, unlawful, offensive, or inconsistent with
          the purpose of the program.
        </p>
        <p>
          Information listed through the Hogcloud Networking program is provided
          for business discovery and legitimate business communication only. It
          may not be harvested, scraped, sold, added to bulk marketing lists, or
          used for spam, robocalls, unsolicited mass emails, deceptive outreach,
          harassment, or any other unwanted solicitation. Anyone contacting a
          listed business is expected to follow applicable privacy,
          telemarketing, email, text-message, and consumer protection laws.
        </p>
        <p>
          A participating business may request that its information be updated,
          hidden, taken down, or removed from the Hogcloud Networking program at
          any time. Hogcloud may also remove or modify a listing at any time for
          operational, legal, quality, safety, or program-management reasons.
        </p>
      </section>

      <section className="legal-content">
        <h2>Custom Orders and Submitted Content</h2>
        <p>
          If you submit names, phrases, artwork, business information, logos, or
          other content to Hogcloud, you confirm that you have the right to
          provide and use that content. You also confirm that the content does
          not infringe the rights of any third party, including trademark,
          copyright, privacy, publicity, or name, image, and likeness rights.
        </p>
        <p>
          Hogcloud may review submitted content and may request clarification,
          decline production, remove a public listing, or cancel and refund an
          order if content cannot be confirmed as compliant or appropriate.
        </p>
      </section>

      <section className="legal-content">
        <h2>Program Communications</h2>
        <p>
          Businesses and customers agree to communicate honestly and
          respectfully. Hogcloud is not responsible for communications,
          transactions, promises, offers, disputes, or services provided between
          third parties who connect through publicly available contact
          information.
        </p>
        <p>
          If a participating business receives unwanted, abusive, misleading, or
          unlawful solicitation connected to a Hogcloud listing, the business may
          contact Hogcloud and request that the listing be changed or removed.
        </p>
      </section>

      <section className="legal-content">
        <h2>Limitation of Liability</h2>
        <p>
          Hogcloud provides site content, program listings, and services on an
          as-available basis. To the fullest extent allowed by law, Hogcloud is
          not liable for indirect, incidental, consequential, special, punitive,
          or lost-profit damages arising from use of the site, services, custom
          products, public listings, or third-party communications.
        </p>
      </section>

      <section className="legal-content">
        <h2>Questions and Removal Requests</h2>
        <p>
          For questions about these terms, custom orders, or the Hogcloud
          Networking program, or to request that business information be
          updated or removed, please contact Hogcloud through the contact
          information provided on the site.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
